import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import logo from "../../assets/logo/logo-white.png";

const Footer = () => {
  const scrollFooter = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  return (
    <footer className="footer-wrapper">
      <div className="footer-container">
        <div className="row">
          <div className="col-12 col-sm-6 col-lg-4">
            <div className="logo">
              <Link to="/" onClick={() => scrollFooter()}>
                <img src={logo} alt="logo" />
              </Link>
            </div>
            <p>
              Soori Corporation is committed to driving business innovation
              through tailored software engineering services across sectors like
              supply chain, healthcare, FinTech, and IoT. We deliver
              high-quality, scalable digital solutions, empowering organizations
              to unlock their full potential with the expertise of our skilled
              developers.
            </p>
            <div className="icons-container">
              <a href="#">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-twitter"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-pinterest"></i>
              </a>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4">
            <h1 className="title">Services</h1>
            <ul>
              <li>
                <Link
                  to="/service/custom-software-development"
                  onClick={() => scrollFooter()}
                >
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; Custom Software Development
                </Link>
              </li>
              <li>
                <Link
                  to="/service/project-based-outsourcing"
                  onClick={() => scrollFooter()}
                >
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; Project Based Outsourcing
                </Link>
              </li>
              <li>
                <Link
                  to="/service/product-line-printing"
                  onClick={() => scrollFooter()}
                >
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; Product Line Printing
                </Link>
              </li>
              <li>
                <Link
                  to="/service/erp-integration"
                  onClick={() => scrollFooter()}
                >
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; ERP Integration
                </Link>
              </li>
              <li>
                <Link
                  to="/service/rfid-and-barcode-solutions"
                  onClick={() => scrollFooter()}
                >
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; RFID & Bar Code Solutions
                </Link>
              </li>
              <li>
                <Link
                  to="/service/identity-management-solution"
                  onClick={() => scrollFooter()}
                >
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; Identity Management Solution
                </Link>
              </li>
              <li>
                <Link
                  to="/service/biometric-and-facial-recognition"
                  onClick={() => scrollFooter()}
                >
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; Biometric & Facial Recognition
                </Link>
              </li>
              <li>
                <Link
                  to="/service/machine-vision-solutions"
                  onClick={() => scrollFooter()}
                >
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; Machine Vision Solutions
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-12 col-sm-6 col-lg-2">
            <h1 className="title">Page Link</h1>
            <ul>
              <li>
                <Link to="/" onClick={() => scrollFooter()}>
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; Home
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={() => scrollFooter()}>
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; Who we are
                </Link>
              </li>
              <li>
                <Link
                  to="/service/custom-software-development"
                  onClick={() => scrollFooter()}
                >
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; Services
                </Link>
              </li>
              <li>
                <Link to="/products/cubix" onClick={() => scrollFooter()}>
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; Products
                </Link>
              </li>
              <li>
                <Link
                  to="/industry/manufacturing"
                  onClick={() => scrollFooter()}
                >
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; Industries
                </Link>
              </li>
              <li>
                <Link to="/contact-us" onClick={() => scrollFooter()}>
                  <i
                    aria-hidden="true"
                    className="fa-solid fa-angles-right"
                  ></i>
                  &nbsp; Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-12 col-sm-6 col-lg-2">
            <h1 className="title">Contact</h1>
            <p>
              SOORI CORPORATION
              <br /> 5152 VILLAGE CREEK DR <br />
              PLANO TEXAS 75093
            </p>
            <ul>
              <li>
                <a href="https://www.sooricorp.com" target="_blank">
                  <i className="fa fa-globe"></i>
                  &nbsp;www.sooricorp.com
                </a>
              </li>
              <li>
                <a href="mailto:www.hello@sooricorp.com">
                  <i className="fa fa-envelope"></i>&nbsp;hello@sooricorp.com
                </a>
              </li>
              <li>
                <a href="tel:+1 469 320 9030">
                  <i className="fa fa-phone"></i>&nbsp;+1 469 320 9030
                </a>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <p className="text-center copyright-text">
          Copyright &copy; {new Date().getFullYear()} Soori | Powered By Soori
        </p>
      </div>
    </footer>
  );
};

export default Footer;
